import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import PriceCheckOutlinedIcon from '@mui/icons-material/PriceCheckOutlined';
import { INavGroup } from '../models/Menu';
import { ROUTES } from '../routes/routes';

export const EmployeeRoutes: INavGroup = {
  id: 'group-employee',
  title: 'RH',
  icon: <PersonOutlineOutlinedIcon />,
  type: 'group',
  // module: 'REGISTER',
  level: 1,
  children: [
    {
      id: 'payments',
      title: 'Folhas de Pagamentos',
      type: 'item',
      url: ROUTES.authenticated.registers.paymentsheet,
      icon: <PriceCheckOutlinedIcon />,
      breadcrumbs: true
      // submodule: 'payments' // Módulo para verificar permissão
    },
    {
      id: 'timesheet',
      title: 'Espelho Ponto',
      type: 'item',
      url: ROUTES.authenticated.registers.timesheet,
      icon: <AccessTimeIcon />,
      breadcrumbs: true
      // submodule: 'timesheet' // Módulo para verificar permissão
    },
    {
      id: 'codeconduct',
      title: 'Código Conduta',
      type: 'item',
      url: ROUTES.authenticated.registers.codeconduct,
      icon: <PersonOutlineOutlinedIcon />,
      breadcrumbs: true
      // submodule: 'codeconduct' // Módulo para verificar permissão
    }
  ]
};
